/**
 * Created by ren_zhangjing on 2017/7/5.
 */
const host = '',
  project = '',
  prefix = host + project +'/api/';
// oldpwd,newpwd,renewpwd
let apis = {
  // 2021
  SignUpCourse: prefix + 'SignUp/Course', //get  choosecourse
  Jump: prefix + 'User/Jump', //choosecourse
  SelectCourse: prefix + 'SignUp/SelectCourse', //choosecourse
  Try: prefix + 'SignUp/Try', //试听
  SignUpDetails: prefix + 'SignUp/Details', //payment
  Invoice: prefix + 'SignUp/Invoice', //payment
  Invoices: prefix + 'Invoice/Last',   //初始化申请发票用户姓名
  MakeUp: prefix + 'Invoice/MakeUp',  //申请发票
  SignUpReSignUp: prefix + 'SignUp/ReSignUp', //payment
  SignUp: prefix + 'SignUp/Pay', //login
  OrderQuery: prefix + 'SignUp/OrderQuery', //login
  Statistics: prefix + 'Index/Statistics', //login
  Course: prefix + 'Course/List', //我的课程 type=1 等待考试 type=3 考试通过 type=0 未完成
  CourseDetails: prefix + 'Course/Details', //courseDetail
  CoursePlay: prefix + 'Course/Play', //courseDetail
  Progress: prefix + 'Course/Progress', //courseDetail
  Questions: prefix + 'Exam/Questions', //onlintest
  ExamSubmit: prefix + 'Exam/Submit', //onlintest
  OrderList: prefix + 'Order/List', //订单列表
  InvoiceList: prefix + 'Invoice/List', //发票列表
//   Notice: prefix + 'Index/Notice', //
  NoticeList: prefix + 'Notice/List', //发票列表
  NoticeDetails: prefix + 'Notice/Details', //发票列表
  NoticeSearch: prefix + 'Notice/Search', //发票列表
  GetPayUrl: prefix + 'SignUp/GetPayUrl', //发票列表
  
  GetPayCode: prefix + 'SignUp/GetPayCode', //发票列表
  Times: prefix + 'Course/Times', //
 
  CourseChapter: prefix + 'Course/Chapter', //
  CourseAssess: prefix + 'Course/Assess', // 评价提交评价 参数 classid star1 star2 star3  assess
  CourseDelAssess: prefix + 'Course/DelAssess', // 删除评价 参数 参数 classid
  GetOpenID: prefix + 'SignUp/GetOpenID', // 获取openid
  WXPay: prefix + 'SignUp/WXPay', // 获取openid
  Upload3: prefix + 'Face/Upload', // 人脸识别
 
  UserUpdate: prefix + 'User/Update', //提交个人信息

  SignUpCheck: prefix + 'SignUp/Check', //选课年份提交
  GetYears: prefix + 'SignUp/GetYears', //获取可选课程年份
  SelectYear: prefix + 'SignUp/SelectYear', //提交可选课程年份
  CourseGetYears: prefix + 'Course/GetYears', //我的课程获取年份
  CourseList: prefix + 'Index/CourseList', //课程列表
  GoPay: prefix + 'Order/GoPay', //订单列表去支付
  Cancel: prefix + 'Order/Cancel', //订单列表取消订单
  PostInvoice: prefix + 'SignUp/PostInvoice', //补开发票列表
  SignUpPostInvoice: prefix + 'SignUp/PostInvoice', //缴费发票


  CourseGoPay: prefix + 'Course/GoPay', //课程下的去支付
  CourseGoSelect: prefix + 'Course/GoSelect', //课程下的去选课
  
  ToPublicClass: prefix + 'Course/ToPublicClass', //跳转公需课

  //
  CheckReg: prefix + 'User/CheckReg', //检查注册身份证号 post
  Register: prefix + 'User/Register', //注册
  
 
  UserDetails: prefix + 'User/Details', // 个人信息
  LoginOut: prefix + 'User/LogOut', //
 
  List: prefix + 'Credit/List', //学分查询
  GXKDetails: prefix + 'Credit/GXKDetails', //公需课详情
  Details: prefix + 'Credit/Details', //专业课课程
  GXKList: prefix + 'Credit/GXKList', //公需课学分列表
  CreditPrint: prefix + 'Credit/Print', //专业课打印
  CreditCheck: prefix + 'Credit/Check', //手机端检查
  GXKPrint: prefix + 'Credit/GXKPrint', //公需课打印
  GXKQRCode: prefix + 'Credit/GXKQRCode', //公需课二维码
  GetParams: prefix + 'Course/GetParams', //我的课程获取年份
  TryList: prefix + 'Index/TryList', //我的课程获取年份
  TryDetails: prefix + 'Index/TryDetails', //我的课程获取年份
  IndexTry: prefix + 'Index/Try', //我的课程获取年份
  UserCheck: prefix + 'User/Check', //检查
  CheckReg: prefix + 'User/CheckReg', //查看男女
  PrintPDF: prefix + 'Credit/PrintPDF', //pdf 
  MobileQRCode: prefix + 'Face/MobileQRCode', //人脸识别二维码
  ContrastStatus: prefix + 'Face/ContrastStatus', //人脸识别二维码查询
  SignUpCourseOne: prefix + 'SignUp/Course', //一键选课 和获取课程

  // 2024
  Practice: prefix + 'Exam/Practice' ,
  ExamList: prefix + 'Exam/List', // 在线考试年份
  ExamQuestions: prefix + 'Exam/Questions',// 在线考试
  QRCode: prefix + 'Index/QRCode', //
  Login: prefix + 'User/Login', //提交个人信息
  ChangePassword: prefix + 'User/ChangePassword', //修改密码
  ResetPwd: prefix + 'User/ResetPwd', //重置密码IndexIsQ
  ExamIsQ: prefix + 'Exam/IsQ', // 调查问卷是否可以
  Questionnaire: prefix + 'Exam/Questionnaire', // 提交调查问卷
  LiveQuestionnaire: prefix + 'Index/LiveQuestionnaire', // 直播扫码评分

  UploadProof: prefix + 'SignUp/UploadProof', //上传文件
SubmitProof: prefix + 'SignUp/SubmitProof ', //提交上传文件
StudyLog: prefix + 'User/StudyLog', //提交上传文件
};
export default apis;



// WEBPACK FOOTER //
// ./src/api/index.js